/**
 * Configuración de países con códigos telefónicos y validación
 * Este archivo contiene la lista de países con su código de teléfono,
 * bandera emoji y límites de dígitos para validación
 */

export interface Country {
  code: string;          // Código ISO del país (ej: 'EC', 'US')
  name: string;          // Nombre del país
  dialCode: string;      // Código de marcación (ej: '+593')
  flag: string;          // Emoji de la bandera
  minDigits: number;     // Mínimo de dígitos permitidos
  maxDigits: number;     // Máximo de dígitos permitidos
  placeholder?: string;  // Placeholder de ejemplo
}

export const COUNTRIES: Country[] = [
  // América Latina
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨', minDigits: 9, maxDigits: 10, placeholder: '987654321' },
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷', minDigits: 10, maxDigits: 11, placeholder: '1123456789' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴', minDigits: 8, maxDigits: 8, placeholder: '71234567' },
  { code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷', minDigits: 10, maxDigits: 11, placeholder: '11987654321' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱', minDigits: 9, maxDigits: 9, placeholder: '912345678' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴', minDigits: 10, maxDigits: 10, placeholder: '3001234567' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷', minDigits: 8, maxDigits: 8, placeholder: '87654321' },
  { code: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺', minDigits: 8, maxDigits: 8, placeholder: '51234567' },
  { code: 'DO', name: 'República Dominicana', dialCode: '+1', flag: '🇩🇴', minDigits: 10, maxDigits: 10, placeholder: '8091234567' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻', minDigits: 8, maxDigits: 8, placeholder: '71234567' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹', minDigits: 8, maxDigits: 8, placeholder: '51234567' },
  { code: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳', minDigits: 8, maxDigits: 8, placeholder: '91234567' },
  { code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽', minDigits: 10, maxDigits: 10, placeholder: '5512345678' },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505', flag: '🇳🇮', minDigits: 8, maxDigits: 8, placeholder: '81234567' },
  { code: 'PA', name: 'Panamá', dialCode: '+507', flag: '🇵🇦', minDigits: 8, maxDigits: 8, placeholder: '61234567' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾', minDigits: 9, maxDigits: 9, placeholder: '981234567' },
  { code: 'PE', name: 'Perú', dialCode: '+51', flag: '🇵🇪', minDigits: 9, maxDigits: 9, placeholder: '987654321' },
  { code: 'PR', name: 'Puerto Rico', dialCode: '+1', flag: '🇵🇷', minDigits: 10, maxDigits: 10, placeholder: '7871234567' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾', minDigits: 8, maxDigits: 9, placeholder: '91234567' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪', minDigits: 10, maxDigits: 10, placeholder: '4121234567' },
  
  // Norte América
  { code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸', minDigits: 10, maxDigits: 10, placeholder: '2025551234' },
  { code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦', minDigits: 10, maxDigits: 10, placeholder: '4165551234' },
  
  // Europa
  { code: 'ES', name: 'España', dialCode: '+34', flag: '🇪🇸', minDigits: 9, maxDigits: 9, placeholder: '612345678' },
  { code: 'FR', name: 'Francia', dialCode: '+33', flag: '🇫🇷', minDigits: 9, maxDigits: 9, placeholder: '612345678' },
  { code: 'DE', name: 'Alemania', dialCode: '+49', flag: '🇩🇪', minDigits: 10, maxDigits: 11, placeholder: '15112345678' },
  { code: 'IT', name: 'Italia', dialCode: '+39', flag: '🇮🇹', minDigits: 9, maxDigits: 10, placeholder: '3123456789' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧', minDigits: 10, maxDigits: 10, placeholder: '7911123456' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹', minDigits: 9, maxDigits: 9, placeholder: '912345678' },
  { code: 'NL', name: 'Países Bajos', dialCode: '+31', flag: '🇳🇱', minDigits: 9, maxDigits: 9, placeholder: '612345678' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32', flag: '🇧🇪', minDigits: 9, maxDigits: 9, placeholder: '471234567' },
  { code: 'CH', name: 'Suiza', dialCode: '+41', flag: '🇨🇭', minDigits: 9, maxDigits: 9, placeholder: '781234567' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹', minDigits: 10, maxDigits: 13, placeholder: '6641234567' },
  { code: 'SE', name: 'Suecia', dialCode: '+46', flag: '🇸🇪', minDigits: 9, maxDigits: 10, placeholder: '701234567' },
  { code: 'NO', name: 'Noruega', dialCode: '+47', flag: '🇳🇴', minDigits: 8, maxDigits: 8, placeholder: '91234567' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45', flag: '🇩🇰', minDigits: 8, maxDigits: 8, placeholder: '32123456' },
  { code: 'FI', name: 'Finlandia', dialCode: '+358', flag: '🇫🇮', minDigits: 9, maxDigits: 10, placeholder: '412345678' },
  { code: 'PL', name: 'Polonia', dialCode: '+48', flag: '🇵🇱', minDigits: 9, maxDigits: 9, placeholder: '512345678' },
  { code: 'GR', name: 'Grecia', dialCode: '+30', flag: '🇬🇷', minDigits: 10, maxDigits: 10, placeholder: '6912345678' },
  { code: 'IE', name: 'Irlanda', dialCode: '+353', flag: '🇮🇪', minDigits: 9, maxDigits: 9, placeholder: '851234567' },
  
  // Asia
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳', minDigits: 11, maxDigits: 11, placeholder: '13912345678' },
  { code: 'JP', name: 'Japón', dialCode: '+81', flag: '🇯🇵', minDigits: 10, maxDigits: 10, placeholder: '9012345678' },
  { code: 'KR', name: 'Corea del Sur', dialCode: '+82', flag: '🇰🇷', minDigits: 9, maxDigits: 10, placeholder: '1012345678' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳', minDigits: 10, maxDigits: 10, placeholder: '9123456789' },
  { code: 'SG', name: 'Singapur', dialCode: '+65', flag: '🇸🇬', minDigits: 8, maxDigits: 8, placeholder: '81234567' },
  { code: 'TH', name: 'Tailandia', dialCode: '+66', flag: '🇹🇭', minDigits: 9, maxDigits: 9, placeholder: '812345678' },
  { code: 'MY', name: 'Malasia', dialCode: '+60', flag: '🇲🇾', minDigits: 9, maxDigits: 10, placeholder: '123456789' },
  { code: 'PH', name: 'Filipinas', dialCode: '+63', flag: '🇵🇭', minDigits: 10, maxDigits: 10, placeholder: '9171234567' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩', minDigits: 10, maxDigits: 12, placeholder: '81234567890' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳', minDigits: 9, maxDigits: 10, placeholder: '912345678' },
  { code: 'AE', name: 'Emiratos Árabes', dialCode: '+971', flag: '🇦🇪', minDigits: 9, maxDigits: 9, placeholder: '501234567' },
  { code: 'SA', name: 'Arabia Saudita', dialCode: '+966', flag: '🇸🇦', minDigits: 9, maxDigits: 9, placeholder: '501234567' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱', minDigits: 9, maxDigits: 9, placeholder: '501234567' },
  { code: 'TR', name: 'Turquía', dialCode: '+90', flag: '🇹🇷', minDigits: 10, maxDigits: 10, placeholder: '5321234567' },
  
  // Oceanía
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺', minDigits: 9, maxDigits: 9, placeholder: '412345678' },
  { code: 'NZ', name: 'Nueva Zelanda', dialCode: '+64', flag: '🇳🇿', minDigits: 9, maxDigits: 10, placeholder: '211234567' },
  
  // África
  { code: 'ZA', name: 'Sudáfrica', dialCode: '+27', flag: '🇿🇦', minDigits: 9, maxDigits: 9, placeholder: '711234567' },
  { code: 'EG', name: 'Egipto', dialCode: '+20', flag: '🇪🇬', minDigits: 10, maxDigits: 10, placeholder: '1001234567' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬', minDigits: 10, maxDigits: 10, placeholder: '8021234567' },
  { code: 'KE', name: 'Kenia', dialCode: '+254', flag: '🇰🇪', minDigits: 9, maxDigits: 9, placeholder: '712345678' },
];

/**
 * Obtiene un país por su código
 * @param code Código ISO del país (ej: 'EC')
 * @returns El objeto Country o undefined si no se encuentra
 */
export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find(c => c.code === code);
}

/**
 * Obtiene un país por su código de marcación
 * @param dialCode Código de marcación (ej: '+593')
 * @returns El primer país que coincida con el código
 */
export function getCountryByDialCode(dialCode: string): Country | undefined {
  return COUNTRIES.find(c => c.dialCode === dialCode);
}

/**
 * Valida un número de teléfono según el país
 * @param phone Número de teléfono (solo dígitos)
 * @param countryCode Código ISO del país
 * @returns true si el número es válido, false en caso contrario
 */
export function validatePhoneNumber(phone: string, countryCode: string): boolean {
  const country = getCountryByCode(countryCode);
  if (!country) return false;
  
  // Eliminar caracteres no numéricos
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Validar longitud
  return cleanPhone.length >= country.minDigits && cleanPhone.length <= country.maxDigits;
}

/**
 * Formatea un número de teléfono completo con código de país
 * @param phone Número de teléfono (solo dígitos)
 * @param countryCode Código ISO del país
 * @returns Número formateado con código de país
 */
export function formatPhoneNumber(phone: string, countryCode: string): string {
  const country = getCountryByCode(countryCode);
  if (!country) return phone;
  
  const cleanPhone = phone.replace(/\D/g, '');
  return `${country.dialCode}${cleanPhone}`;
}

/**
 * Obtiene el mensaje de error de validación para un número de teléfono
 * @param countryCode Código ISO del país
 * @returns Mensaje descriptivo de la validación
 */
export function getPhoneValidationMessage(countryCode: string): string {
  const country = getCountryByCode(countryCode);
  if (!country) return 'Seleccione un país';
  
  if (country.minDigits === country.maxDigits) {
    return `Debe tener exactamente ${country.maxDigits} dígitos`;
  }
  return `Debe tener entre ${country.minDigits} y ${country.maxDigits} dígitos`;
}

/**
 * Separa un número de teléfono completo en código de país y número
 * @param fullPhone Número completo con código de país (ej: '+593987654321')
 * @returns Objeto con countryCode (ISO) y phoneNumber (solo dígitos), o null si no se puede parsear
 */
export function parsePhoneNumber(fullPhone: string): { countryCode: string, phoneNumber: string } | null {
  if (!fullPhone || !fullPhone.startsWith('+')) {
    return null;
  }

  // Intentar encontrar el código de país más largo primero (hasta 4 dígitos)
  for (let i = 4; i >= 1; i--) {
    const dialCode = fullPhone.substring(0, i + 1); // +1, +52, +593, etc.
    const country = getCountryByDialCode(dialCode);
    
    if (country) {
      const phoneNumber = fullPhone.substring(i + 1);
      return {
        countryCode: country.code,
        phoneNumber: phoneNumber
      };
    }
  }

  return null;
}
